import axios from "axios";
// import { getRandomNumber } from "../../method/getRandomNumber";

const AxiosCustom = (_config, _data, headers = {}) => {
  let userLocal = localStorage.getItem("persist:admin")
    ? JSON.parse(localStorage.getItem("persist:admin")).user
    : null;

  let { token, member_id } = userLocal
    ? JSON.parse(userLocal)
    : {
        token: "3cf61fab-b50a-410f-9d59-3357ee4706fe",
        member_id: "_0zehXYBdxxYGfkX5_wd",
      };

  let config = {
    baseURL: getUrl(),
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      ...headers,
    },
    ..._config,
    data: {
      api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
      token: token,
      member_id: member_id,
      ..._data,
    },
  };

  return axios(config);
};

export function getUrl() {
  let protocol = window.location.protocol;
  let hostName = window.location.hostname;

  if (!protocol || !hostName || hostName === "localhost") {
    return "https://www.pouyanbroker.ir/GradDB/V1/";
    // return "http://172.18.39.154:41790/GradDB/V1/"
    // return "http://172.18.39.150:5001/GradDB/V1";
    return "http://172.18.39.150:5001/GradDB/V1";

    // return `http://172.18.39.150:5001/Hoghoghi/V1/`;
    return "https://pouyanbroker.ir/GradDB/V1/";
    return "http://192.168.231.66:7010/GradDB/V1/";
  }

  return `${protocol}//${hostName}/GradDB/V1/`;
}

export default AxiosCustom;
